import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { updatePhaseFiltersLocation, requestRegionList } from 'actionCreators';
import { getPhaseFiltersLocation, getRegionList } from '../../../../../../reducers';
import StoreSelect from 'components/formElements/StoreSelect';
import WorkroomSelect from 'components/formElements/WorkroomSelect';
import ProductTypeSelect from 'components/formElements/ProductTypeSelect';
import SurfaceTypeSelect from 'components/formElements/SurfaceTypeSelect';
import ReactSelect from 'components/StyledSelect/react_select';
import reactSelectStyles from 'components/ReactSelect/styles';
import phaseFilterStyles from 'phaseFilters.scss';
import { PhaseFilterLocationType } from 'types/filter';
import { generateSource } from '../../../../../../utils';

const selectStyles = `${reactSelectStyles.selectWrapper} ${phaseFilterStyles.selectWrapper}`;

class PhaseLocationFilters extends Component {
  constructor(props) {
    super(props);
    this.handleWorkrooms = this.handleSelectChange.bind(this, 'workroom');
    this.handleStores = this.handleSelectChange.bind(this, 'store');
    this.handleRegions = this.handleSelectChange.bind(this, 'region');
    this.handleSurfaceType = this.handleSelectChange.bind(this, 'surface_type');
    this.handleProductType = this.handleProductType.bind(this, 'product_type');
  }

  componentDidMount() {
    const { regions } = this.props;
    if (!regions || regions.length === 0) {
      this.props.requestRegionList();
    }
  }

  handleSelectChange = (key, values) => this.props.updatePhaseFiltersLocation({
    ...this.props.filters,
    [key]: (values || []).map(v => v.value),
  });

  handleProductType = (key, values) => this.props.updatePhaseFiltersLocation({
    ...this.props.filters,
    [key]: values ? values.value : undefined,
  });

  render = () => (<div className={phaseFilterStyles.content}>
    {!this.props.hideWorkroomSelect && <WorkroomSelect
      value={this.props.filters.workroom}
      onChange={this.handleWorkrooms}
      className={phaseFilterStyles.selectWrapper}
    />}
    <StoreSelect
      className={selectStyles}
      value={this.props.filters.store}
      onChange={this.handleStores}
      placeholder="All Stores"
    />
    <ReactSelect
      key="regions"
      className={selectStyles}
      label="Store Region"
      name="store-region"
      placeholder="All Regions"
      multi
      options={generateSource(this.props.regions)}
      value={this.props.filters.region}
      onChange={this.handleRegions}
    />
    <SurfaceTypeSelect
      multi
      onChange={this.handleSurfaceType}
      value={this.props.filters.surface_type}
      className={selectStyles}
      placeholder="All Surface Types"
    />
    <ProductTypeSelect
      className={selectStyles}
      value={this.props.filters.product_type}
      onChange={this.handleProductType}
    />
  </div>);
}

PhaseLocationFilters.defaultProps = {
  filters: {
    workroom: [],
    store: [],
    region: [],
    surface_type: [],
  },
  hideWorkroomSelect: false,
  regions: [],
};

PhaseLocationFilters.propTypes = {
  filters: PhaseFilterLocationType.isRequired,
  updatePhaseFiltersLocation: PropTypes.func.isRequired,
  requestRegionList: PropTypes.func.isRequired,
  hideWorkroomSelect: PropTypes.bool,
  regions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  })),
};

const mapStateToProps = state => ({
  filters: getPhaseFiltersLocation(state),
  regions: getRegionList(state),
});

export default connect(mapStateToProps, {
  updatePhaseFiltersLocation,
  requestRegionList,
})(PhaseLocationFilters);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseList/components/PhaseLocationFilters.jsx